export const getConfigVars = state => {
    return state.configVars;
};

export const getConfigVar = state => key => {
    return state.configVars[key];
};

export const getFlowFlags = (state) => state.flowFlags;
export const getAllowPeriodicSubscriptions = (state) => state.flowFlags.allowPeriodicSubscriptions;
export const getAllowSendAccountWithoutOperations = (state) => state.flowFlags.allowSendAccountWithoutOperations;
export const getAllowPensionPlans = (state) => state.flowFlags.allowPensionPlans;
export const getAllowFiscalItems = (state) => state.flowFlags.allowFiscalItems;
export const getAllowExternalCodesFromSM = (state) => state.flowFlags.allowExternalCodesFromSM;
export const getAllowMarketerChange = (state) => state.flowFlags.allowMarketerChange;
export const getAllowAML = (state) => state.flowFlags.allowAML;
export const getNrbeRequired = (state) => state.flowFlags.nrbeRequired;
export const getAllowEditSubdistributor = (state) => state.flowFlags.allowEditSubdistributor;
export const getAllowAutoClassSelection = (state) => state.flowFlags.allowAutoClassSelection;
export const getS3Path = (state) => state.flowFlags.s3Path;
export const getDefaultDistributorUuid = (state) => state.flowFlags.defaultDistributorUuid;
  
